<template>
  <v-card class="mx-auto" max-width="400" outlined id="promotion">
    <v-img
      v-if="img"
      contain
      height="320px"
      :src="imgUrl + img"
      class="mb-4"
    ></v-img>
    <v-img
      v-else
      contain
      height="320px"
      :src="`${publicPath}promotion_placeholder.png`"
      class="mb-4"
    ></v-img>
    <v-card-text style="height: 100px; overflow: auto"
      >{{ promotion.body }}
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn
        :disabled="!activated"
        @click="printPromotionDialogModel = true"
        color="primary"
        text
      >
        {{ printPromotionDialogButtonText }}
      </v-btn>
    </v-card-actions>
    <PrintPromotionDialog
      v-model="printPromotionDialogModel"
      :chosen_promotion="promotion"
    ></PrintPromotionDialog>
  </v-card>
</template>

<script>
import PrintPromotionDialog from "./PrintPromotionDialog";

export default {
  components: { PrintPromotionDialog },
  props: {
    promotionInit: {
      type: Object,
      required: true
    },
    obtainedStamps: {
      type: Number,
      required: true
    },
    img: {
      type: String,
      required: false,
      default: null
    }
  },
  name: "Promotion",
  data() {
    return {
      imgUrl: process.env.VUE_APP_IMG_URL,
      promotion: this.promotionInit,
      printPromotionDialogModel: false,
      publicPath: process.env.BASE_URL
    };
  },
  computed: {
    activated() {
      return (
        this.obtainedStamps >= this.promotionInit.stamps_required &&
        this.promotionInit.user_promotions.length > 0
      );
    },
    printPromotionDialogButtonText() {
      return this.activated
        ? this.$t("button.activate_promotion")
        : this.$t("button.promotion_stamps_required", {
            stamps_required:
              this.promotion.stamps_required - this.obtainedStamps
          });
    }
  }
};
</script>

<style scoped></style>
